import { Card, Empty, Flex } from 'antd'

import { usePatientTreatmentServiceGetPatientConsultationListEndpoint } from 'src/api/queries'
import { AppointmentCard, PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

export const AppointmentsPage = () => {
  const { t } = useLocales()

  const { data } =
    usePatientTreatmentServiceGetPatientConsultationListEndpoint()

  return (
    <PageBreadcrumbs
      title={t('menu.appointments')}
      items={[{ title: t('menu.appointments') }]}
    >
      {data?.data?.length ? (
        <Flex vertical gap={16}>
          <Card bordered={false}>
            <Flex vertical gap={24}>
              {data?.data?.map((appointment) => (
                <AppointmentCard key={appointment?.id} data={appointment} />
              ))}
            </Flex>
          </Card>
        </Flex>
      ) : (
        <Empty />
      )}
    </PageBreadcrumbs>
  )
}
